export default __webpack_public_path__ + "static/media/view-refresh.1fe4110e.png";